import React from 'react';
import { ASSET_READ, hasPrivilege, PLAYLIST_READ } from 'utils/privileges';
import SimpleShareContentModal from './SimpleShareContentModal';
import AdminShareContentModal from './AdminShareContentModal';
export function ShareContentModal(_ref) {
  var data = _ref.data,
    _ref$initialShareType = _ref.initialShareType,
    initialShareType = _ref$initialShareType === void 0 ? null : _ref$initialShareType,
    onClose = _ref.onClose;
  var isContentAdmin = hasPrivilege(ASSET_READ) || hasPrivilege(PLAYLIST_READ);
  if (isContentAdmin) {
    return /*#__PURE__*/React.createElement(AdminShareContentModal, {
      data: data,
      initialShareType: initialShareType,
      onClose: onClose
    });
  }
  return /*#__PURE__*/React.createElement(SimpleShareContentModal, {
    data: data,
    onClose: onClose
  });
}
export default ShareContentModal;
export { default as SimpleShareContentModal } from './SimpleShareContentModal';
export { default as AdminShareContentModal } from './AdminShareContentModal';
export { default as useGetSharingPermissions } from './shared/useGetSharingPermissions';
export * from './shared/types';